import { ArtworkIcon, ContentIcon } from "@dropbox/dash-component-library";
import { Banner } from "@dropbox/dig-components/banner";
import { Button } from "@dropbox/dig-components/buttons";
import { Text } from "@dropbox/dig-components/typography";
import { Box, ThemeContainer, ThemeProvider } from "@dropbox/dig-foundations";
import i18n from "@mirage/translations";

import styles from "./AddAppsUpsell.module.css";

type AddAppsUpsellProps = {
  onDismiss: () => void;
  onOpenAddApps: () => void;
};

export const AddAppsUpsell = ({
  onDismiss,
  onOpenAddApps,
}: AddAppsUpsellProps) => {
  return (
    <Banner
      type="attention"
      withLeftIcon={false}
      withCloseButton={"close"}
      className={styles.addAppsUpsellBanner}
      onRequestClose={onDismiss}
    >
      <Banner.Message className={styles.addAppsUpsellMessage}>
        <AddAppsUpsellIcons />
        <Box>
          <Text className={styles.addAppsUpsellTitle}>
            {i18n.t("add_apps_upsell_banner_title")}
          </Text>
          <Text className={styles.addAppsUpsellSubtitle}>
            {i18n.t("add_apps_upsell_banner_subtitle")}
          </Text>
          <Button variant="primary" size="small" onClick={onOpenAddApps}>
            {i18n.t("add_apps")}
          </Button>
        </Box>
      </Banner.Message>
    </Banner>
  );
};

interface UpsellIconProps {
  icon: React.ComponentProps<typeof ArtworkIcon>["icon"];
}

export const UpsellIcon = ({ icon }: UpsellIconProps) => {
  return (
    <Box className={styles.appIconWrapper} data-testid="upsell-icon">
      <ContentIcon
        size={"small"}
        className={styles.appContentIcon}
        icon={<ArtworkIcon icon={icon} />}
      />
    </Box>
  );
};

export const AddAppsUpsellIcons = () => {
  // App icons always on white background regardless of theme,
  // so we need to wrap them in bright theme to be able to see them.
  return (
    <Box
      className={styles.addAppsUpsellIconContainer}
      data-testid="add-apps-upsell-icons"
    >
      <Box className={styles.iconInnerContainer}>
        <ThemeProvider mode="bright">
          <ThemeContainer>
            <UpsellIcon icon="MsOutlook" />
            <UpsellIcon icon="GoogleMail" />
            <UpsellIcon icon="Notion" />
            <UpsellIcon icon="Smartsheet" />
          </ThemeContainer>
        </ThemeProvider>
      </Box>
    </Box>
  );
};
